import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    icon: {
        borderRadius: theme.spacing(1),
        boxSizing: "border-box",
        padding: theme.spacing(2),
    },
    iconDisabled: {
        color: theme.palette.emteria.border.primary,
        border: "1px solid " + theme.palette.emteria.border.primary,
    },
    icons: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(2),
        color: theme.palette.emteria.border.primary,
    },
    collapsingRowContent: {
        padding: theme.spacing(2),
        width: "100%",
        maxWidth: "100%",
        minHeight: 36,
        textAlign: "left",
        wordWrap: "break-word",
    },
    collapseBtn: {
        "&:focus": {
            outline: "none",
        },
    },
    overflow: {
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    buttonBox: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: theme.spacing(1),
        height: 50,
    },
    customCollapse: {
        "& .MuiCollapse-wrapper": {
            maxWidth: "650px",
        },
    },
}));
